import { render, staticRenderFns } from "./StatsNumber.vue?vue&type=template&id=72fb57fd&"
import script from "./StatsNumber.vue?vue&type=script&lang=js&"
export * from "./StatsNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports